"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValuesOfStringEnum = void 0;
const getValuesOfStringEnum = (enumObject) => Object.keys(enumObject).map((key) => enumObject[key]);
exports.getValuesOfStringEnum = getValuesOfStringEnum;
